import type { RefObject } from 'react';
import { useEffect } from 'react';

export const useClickOutside = (
    ref: RefObject<HTMLDivElement>,
    callback: (event?: Event) => void,
): void => {
    useEffect(() => {
        const runCallback = (event: Event) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                callback(event);
            }
        };

        document.addEventListener('click', runCallback, true);
        window.addEventListener('blur', callback);

        return () => {
            document.removeEventListener('click', runCallback, true);
            window.removeEventListener('blur', callback);
        };
    }, [ref]);
};
